module.exports = __webpack_public_path__ + "static/media/recommendation_activity.40122bda.svg";